import { ChevronDown, ChevronUp } from "lucide-react";

const INK = "#0F1B2D";
const CYAN = "#4F86D6";
const CYAN_DARK = "#0E509C";
const PINK_DARK = "#10346E";
const fmt = (n) => `$${Math.round(n).toLocaleString()}`;
import { ROLES, commitDiscount } from "./pricing";

export function FractionalTeam({ roles, setRole, showTeam, setShowTeam, teamLines }) {
  return (
          <div className="rt-card p-6">
            <button type="button" onClick={() => setShowTeam((s) => !s)} data-testid="team-toggle" className="w-full flex items-center justify-between gap-3 text-left">
              <div>
                <div className="rt-eyebrow mb-1">Optional · fractional compliance team</div>
                <div className="text-[13px]" style={{ color: INK, opacity: 0.65 }}>
                  Need more than the plan? Anything beyond it is quoted first and billed hourly. Lock in hours for a role and it earns its own discount — 10+ hrs/mo → 10% · 20+ → 15% · 40+ → 20%.
                </div>
              </div>
              {showTeam ? <ChevronUp className="h-5 w-5 flex-shrink-0" style={{ color: CYAN_DARK }} /> : <ChevronDown className="h-5 w-5 flex-shrink-0" style={{ color: CYAN_DARK }} />}
            </button>
            {(showTeam || teamLines.length > 0) && (
              <div className="space-y-3 mt-4" data-testid="team-section">
                {ROLES.map((r) => {
                  const st = roles[r.key];
                  const pct = r.discountable && st.mode === "committed" ? commitDiscount(st.hours) : 0;
                  const effRate = r.rate * (1 - pct / 100);
                  return (
                    <div key={r.key} className="rounded-2xl border p-4 transition-colors" style={{ borderColor: st.on ? CYAN : "#E5EDF5", background: st.on ? `${CYAN}0d` : "#fff" }}>
                      <div className="flex flex-wrap items-center justify-between gap-3">
                        <label className="flex items-center gap-3 cursor-pointer">
                          <input type="checkbox" checked={st.on} onChange={(e) => setRole(r.key, { on: e.target.checked })} data-testid={`role-toggle-${r.key}`} className="h-4 w-4 accent-[#0E509C]" />
                          <div>
                            <div className="rt-h text-[15px]" style={{ color: INK }}>{r.label}</div>
                            {r.sub && <div className="text-[11.5px] italic" style={{ color: INK, opacity: 0.55 }}>{r.sub}</div>}
                            <div className="text-[12px]" style={{ color: INK, opacity: 0.6 }}>${r.rate}/hr{r.discountable ? " · commitment discount eligible" : " · flat rate, no discount"}</div>
                          </div>
                        </label>
                        {st.on && (
                          <div className="rt-h text-lg" data-testid={`role-monthly-${r.key}`} style={{ color: CYAN_DARK }}>
                            {st.mode === "committed" ? `${fmt(st.hours * effRate)}/mo` : `~${fmt(st.hours * r.rate)}/mo est.`}
                          </div>
                        )}
                      </div>
                      {st.on && (
                        <div className="mt-3 grid sm:grid-cols-[1fr_auto] gap-3 items-center">
                          <div>
                            <input type="range" min={r.min} max={r.max} value={st.hours} onChange={(e) => setRole(r.key, { hours: Number(e.target.value) })} data-testid={`role-hours-${r.key}`} className="w-full accent-[#0E509C]" />
                            <div className="text-[12px] font-bold" style={{ color: INK }}>
                              {st.hours} hrs/mo
                              {pct > 0 && <span className="ml-2 px-2 py-0.5 rounded-full text-[11px]" style={{ background: `${PINK_DARK}15`, color: PINK_DARK }}>{pct}% off → ${effRate % 1 ? effRate.toFixed(2) : Math.round(effRate)}/hr</span>}
                              {r.discountable && st.mode === "committed" && pct === 0 && <span className="ml-2 text-[11px] opacity-55">commit 10+ hrs to unlock 10% off</span>}
                            </div>
                          </div>
                          {r.discountable && (
                            <div className="flex rounded-full border overflow-hidden text-[12px] font-bold" style={{ borderColor: `${CYAN_DARK}30` }}>
                              {["committed", "adhoc"].map((m) => (
                                <button key={m} type="button" onClick={() => setRole(r.key, { mode: m })} data-testid={`role-mode-${r.key}-${m}`} className="px-3 py-1.5 transition-colors"
                                        style={{ background: st.mode === m ? CYAN_DARK : "#fff", color: st.mode === m ? "#fff" : CYAN_DARK }}>
                                  {m === "committed" ? "Committed" : "Ad-hoc"}
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

  );
}
